import { Modal } from "@maysoft/common-component-react"
import { useEffect, useState } from "react"
import SimpleSettingForm from "../container/simpleConfig"
import Strings from "constants/strings"
import BasicInfoSection from "../container/baseInfo"

export type SettingProps = {
    serviceName: string
    tenantName: string
    visibled: boolean
    title?: string
    value: string
    onClose: () => void
    onSubmit: (value: string) => void
}

const SimpleSettingPopup = ({
    serviceName,
    tenantName,
    visibled,
    title,
    value,
    onClose,
    onSubmit
}: SettingProps) => {

    const [val, setVal] = useState("")

    useEffect(() => {
        setVal(value || "")
    }, [value])

    return (
        <Modal
            visible={visibled}
            maxWidth="xs"
            fullWidth
            title={title}
            buttonAction={Strings.Common.SAVE}
            onClose={onClose}
            onAction={() => onSubmit(val)}
            hasActionButton
        >
            <BasicInfoSection
                title={Strings.SETTING.BASIC}
                items={[
                    {
                        label: Strings.SETTING.SERVICE,
                        value: serviceName
                    },
                    {
                        label: Strings.SETTING.TENANT,
                        value: tenantName
                    }
                ]}
            />
            <SimpleSettingForm
                value={val}
                onChange={setVal}
            />
        </Modal>
    )
}

export default SimpleSettingPopup